import * as manageOrders from './manageOrders';

const reducers = {
  ...manageOrders,
};

export default reducers;
